import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AppStateManageService } from './app-state-manage.service';

@Injectable({
  providedIn: 'root',
})
export class ChapterStateManagement {
  public ChapterRef: number = 0
  public SelectedChapterRef = signal<number>(this.ChapterRef);
  public SelectedChapterName = signal<string>('');
  // NEW: Signal to hold the list of chapters (for dropdown)
  public ChapterList = signal<{ ref: number, name: string }[]>([]);

  constructor(private appStateManagement: AppStateManageService) { }

  //  NEW: Method to set initial list or update list
  // setChapterList(list: Chapter[]) {
  //   this.ChapterList.set(list.map(chapter => ({ ref: chapter.p.Ref, name: chapter.p.Name })));
  // }

  setChapterRefName(ChapterRef: number, ChapterName: string) {
    this.clearCurrentChapterRefName();

    this.SelectedChapterRef.set(ChapterRef);
    this.SelectedChapterName.set(ChapterName);
    this.appStateManagement.StorageKey.setItem('SelectedChapterRef', ChapterRef.toString());
    this.appStateManagement.StorageKey.setItem('SelectedChapterName', ChapterName);
  }

  setChapterRef(ChapterRef: number) {
    this.clearCurrentChapterRefName();

    this.SelectedChapterRef.set(ChapterRef);
    this.appStateManagement.StorageKey.setItem('SelectedChapterRef', ChapterRef.toString());
  }

  getCurrentChapterRef(): number {
    return this.SelectedChapterRef();
  }

  getCurrentChapterName(): string {
    return this.SelectedChapterName(); // Returns the current signal value
  }

  getChapterList() {
    return this.ChapterList;
  }

  clearCurrentChapterRefName = () => {
    this.SelectedChapterRef.set(0);
    this.SelectedChapterName.set('');
    this.appStateManagement.StorageKey.setItem('SelectedChapterRef', '0');
    this.appStateManagement.StorageKey.setItem('SelectedChapterName', '');
  }
}